import React from "react";
import { ESTADOS_ACADEMICOS } from "../constants/estadosAcademicos";

export default function EstudiantesFilters({ filtros, setFiltros, limpiarFiltros }) {
  return (
    <div className="management-card est-filters-card management-filters-card mb-4">
      <div className="row g-3 align-items-end">
        <div className="col-12 col-md-4">
          <label className="form-label management-label mb-1">Buscar</label>
          <input
            type="search"
            className="form-control"
            placeholder="Nombre, documento o email"
            value={filtros.search}
            onChange={(e) => setFiltros((prev) => ({ ...prev, search: e.target.value }))}
          />
        </div>
        <div className="col-6 col-md-4">
          <label className="form-label management-label mb-1">Estado académico</label>
          <select
            className="form-select"
            value={filtros.estado_academico}
            onChange={(e) => setFiltros((prev) => ({ ...prev, estado_academico: e.target.value }))}
          >
            <option value="all">Todos</option>
            {ESTADOS_ACADEMICOS.map((estado) => (
              <option key={estado.value} value={estado.value}>
                {estado.label}
              </option>
            ))}
          </select>
        </div>
        <div className="col-6 col-md-4">
          <label className="form-label management-label mb-1">Activo</label>
          <div className="input-group">
            <select
              className="form-select"
              value={filtros.activo}
              onChange={(e) => setFiltros((prev) => ({ ...prev, activo: e.target.value }))}
            >
              <option value="all">Todos</option>
              <option value="1">Activos</option>
              <option value="0">Inactivos</option>
            </select>
            <button type="button" className="btn management-btn-primary management-btn-tiny" onClick={limpiarFiltros}>
              <i className="bi bi-eraser-fill me-1" />
              Limpiar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

